export interface KarnatakaCity {
  id: string;
  name: string;
  region: string;
  listingCount: number;
  description: string;
  tags: string[];
  avgRentRange: string;
  image: string;
}

export const karnatakaCities: KarnatakaCity[] = [
  {
    id: "bengaluru",
    name: "Bengaluru",
    region: "South Karnataka",
    listingCount: 28,
    description: "India's Silicon Valley — industrial, commercial & tech park plots",
    tags: ["Industrial", "Commercial", "Warehouses", "Data Centres"],
    avgRentRange: "₹65K–3.5L/month",
    image: "https://readdy.ai/api/search-image?query=Modern%20Bengaluru%20cityscape%20aerial%20view%20with%20tech%20parks%20and%20industrial%20areas%2C%20golden%20hour%20warm%20light%2C%20contemporary%20India%20urban%20landscape%2C%20clean%20composition%2C%20warm%20amber%20tones%2C%20cinematic%20wide%20angle%20photography%2C%20highly%20detailed&width=600&height=400&seq=city-bengaluru-01&orientation=landscape",
  },
  {
    id: "mysuru",
    name: "Mysuru",
    region: "South Karnataka",
    listingCount: 12,
    description: "Heritage city with booming highway commercial and logistics land",
    tags: ["Commercial", "Logistics", "Events", "Hotels"],
    avgRentRange: "₹35K–90K/month",
    image: "https://readdy.ai/api/search-image?query=Mysuru%20cityscape%20with%20heritage%20architecture%20and%20modern%20highway%20infrastructure%2C%20warm%20golden%20afternoon%20light%2C%20South%20Karnataka%20landscape%2C%20mix%20of%20old%20and%20new%20India%2C%20cinematic%20photography%2C%20warm%20amber%20tones%2C%20highly%20detailed&width=600&height=400&seq=city-mysuru-01&orientation=landscape",
  },
  {
    id: "hubli",
    name: "Hubli",
    region: "North Karnataka",
    listingCount: 9,
    description: "Railway hub — ideal for warehousing and distribution centres",
    tags: ["Warehouses", "Cold Storage", "Logistics", "Commercial"],
    avgRentRange: "₹25K–70K/month",
    image: "https://readdy.ai/api/search-image?query=Hubli%20city%20industrial%20area%20with%20railway%20tracks%20and%20warehouse%20buildings%2C%20warm%20morning%20light%2C%20North%20Karnataka%20logistics%20hub%2C%20India%20industrial%20corridor%2C%20cinematic%20wide%20angle%20photography%2C%20warm%20amber%20tones%2C%20highly%20detailed&width=600&height=400&seq=city-hubli-01&orientation=landscape",
  },
  {
    id: "mangaluru",
    name: "Mangaluru",
    region: "Coastal Karnataka",
    listingCount: 7,
    description: "Coastal port city — logistics, cold chain & port-adjacent land",
    tags: ["Logistics", "Cold Chain", "Commercial", "Resorts"],
    avgRentRange: "₹40K–1.5L/month",
    image: "https://readdy.ai/api/search-image?query=Mangalore%20coastal%20port%20city%20with%20harbor%20and%20shipping%20containers%2C%20warm%20sunset%20light%20over%20Arabian%20Sea%2C%20coastal%20Karnataka%20landscape%2C%20India%20port%20city%2C%20cinematic%20photography%2C%20warm%20amber%20and%20teal%20tones%2C%20highly%20detailed&width=600&height=400&seq=city-mangaluru-01&orientation=landscape",
  },
  {
    id: "belagavi",
    name: "Belagavi",
    region: "North Karnataka",
    listingCount: 6,
    description: "Border industrial hub — KIADB zones and airport-adjacent plots",
    tags: ["Industrial", "Food Processing", "Auto Parts", "Aerospace"],
    avgRentRange: "₹30K–85K/month",
    image: "https://readdy.ai/api/search-image?query=Belagavi%20industrial%20zone%20with%20factory%20buildings%20and%20open%20industrial%20land%2C%20warm%20afternoon%20light%2C%20North%20Karnataka%20border%20region%2C%20India%20manufacturing%20hub%2C%20cinematic%20wide%20angle%20photography%2C%20warm%20amber%20tones%2C%20highly%20detailed&width=600&height=400&seq=city-belagavi-01&orientation=landscape",
  },
  {
    id: "ballari",
    name: "Ballari",
    region: "Central Karnataka",
    listingCount: 5,
    description: "Steel corridor — heavy industrial and mining ancillary plots",
    tags: ["Heavy Industry", "Steel Ancillary", "Mining", "Warehousing"],
    avgRentRange: "₹50K–2L/month",
    image: "https://readdy.ai/api/search-image?query=Ballari%20steel%20industry%20area%20with%20iron%20ore%20mining%20landscape%2C%20dramatic%20industrial%20scenery%2C%20Central%20Karnataka%20region%2C%20India%20heavy%20industry%20corridor%2C%20warm%20golden%20light%2C%20cinematic%20photography%2C%20amber%20and%20earth%20tones%2C%20highly%20detailed&width=600&height=400&seq=city-ballari-01&orientation=landscape",
  },
  {
    id: "kalaburagi",
    name: "Kalaburagi",
    region: "North Karnataka",
    listingCount: 5,
    description: "Dry-land agri & commercial plots on NH-50 corridor",
    tags: ["Commercial", "Agriculture", "Retail", "Fuel Stations"],
    avgRentRange: "₹18K–50K/month",
    image: "https://readdy.ai/api/search-image?query=Kalaburagi%20highway%20commercial%20corridor%20with%20national%20highway%20passing%20through%2C%20dry%20land%20agricultural%20landscape%2C%20North%20Karnataka%20region%2C%20warm%20golden%20hour%20light%2C%20India%20roadside%20commercial%20real%20estate%2C%20cinematic%20photography%2C%20amber%20tones%2C%20highly%20detailed&width=600&height=400&seq=city-kalaburagi-01&orientation=landscape",
  },
  {
    id: "shivamogga",
    name: "Shivamogga",
    region: "Malnad / Western Ghats",
    listingCount: 8,
    description: "Western Ghats plantation hub — areca, coffee & agri-tourism",
    tags: ["Plantations", "Agri-Tourism", "Horticulture", "Resorts"],
    avgRentRange: "₹15K–55K/month",
    image: "https://readdy.ai/api/search-image?query=Shimoga%20Western%20Ghats%20lush%20green%20landscape%20with%20areca%20nut%20plantations%20and%20coffee%20estates%2C%20misty%20mountain%20backdrop%2C%20Malnad%20region%20Karnataka%2C%20warm%20morning%20light%20filtering%20through%20trees%2C%20cinematic%20nature%20photography%2C%20rich%20green%20and%20amber%20tones%2C%20highly%20detailed&width=600&height=400&seq=city-shivamogga-01&orientation=landscape",
  },
  {
    id: "udupi",
    name: "Udupi",
    region: "Coastal Karnataka",
    listingCount: 4,
    description: "Coastal beauty — resort, residential & beachfront land",
    tags: ["Resorts", "Homestays", "Residential", "Beachfront"],
    avgRentRange: "₹30K–1.2L/month",
    image: "https://readdy.ai/api/search-image?query=Udupi%20coastal%20Karnataka%20beach%20with%20palm%20trees%20and%20pristine%20shoreline%2C%20warm%20sunset%20golden%20light%20over%20Arabian%20Sea%2C%20India%20beachfront%20property%20potential%2C%20serene%20coastal%20landscape%2C%20cinematic%20photography%2C%20warm%20amber%20and%20teal%20tones%2C%20highly%20detailed&width=600&height=400&seq=city-udupi-01&orientation=landscape",
  },
  {
    id: "tumakuru",
    name: "Tumakuru",
    region: "South Karnataka",
    listingCount: 10,
    description: "Agri-rich hinterland — horticulture, floriculture & organic farms",
    tags: ["Agriculture", "Horticulture", "Organic Farming", "Warehouses"],
    avgRentRange: "₹12K–35K/month",
    image: "https://readdy.ai/api/search-image?query=Tumkur%20agricultural%20landscape%20with%20green%20fields%20and%20farmland%2C%20South%20Karnataka%20rural%20scenery%2C%20warm%20golden%20hour%20light%2C%20India%20agrarian%20countryside%2C%20cinematic%20wide%20angle%20photography%2C%20warm%20amber%20and%20green%20tones%2C%20highly%20detailed&width=600&height=400&seq=city-tumakuru-01&orientation=landscape",
  },
  {
    id: "vijayapura",
    name: "Vijayapura",
    region: "North Karnataka",
    listingCount: 4,
    description: "High-irradiance zone — solar farms & dry-land agriculture",
    tags: ["Solar Farms", "Agriculture", "Agri-Solar", "Commercial"],
    avgRentRange: "₹25K–75K/month",
    image: "https://readdy.ai/api/search-image?query=Vijayapura%20Bijapur%20historical%20city%20with%20Gol%20Gumbaz%20monument%20and%20open%20dry%20land%2C%20North%20Karnataka%20arid%20landscape%2C%20warm%20afternoon%20light%2C%20India%20historical%20and%20agricultural%20region%2C%20cinematic%20photography%2C%20amber%20and%20earth%20tones%2C%20highly%20detailed&width=600&height=400&seq=city-vijayapura-01&orientation=landscape",
  },
  {
    id: "davanagere",
    name: "Davanagere",
    region: "Central Karnataka",
    listingCount: 4,
    description: "Central Karnataka logistics — parking, events & distribution",
    tags: ["Parking", "Events", "Distribution", "Markets"],
    avgRentRange: "₹12K–30K/month",
    image: "https://readdy.ai/api/search-image?query=Davanagere%20central%20Karnataka%20city%20with%20commercial%20streets%20and%20open%20market%20areas%2C%20warm%20evening%20light%2C%20India%20logistics%20and%20distribution%20hub%2C%20cinematic%20wide%20angle%20photography%2C%20warm%20amber%20tones%2C%20urban%20and%20rural%20mix%2C%20highly%20detailed&width=600&height=400&seq=city-davanagere-01&orientation=landscape",
  },
];

export const regionFilters = [
  { label: "All Regions", value: "All" },
  { label: "North Karnataka", value: "North Karnataka" },
  { label: "South Karnataka", value: "South Karnataka" },
  { label: "Coastal Karnataka", value: "Coastal Karnataka" },
  { label: "Central Karnataka", value: "Central Karnataka" },
  { label: "Malnad / Western Ghats", value: "Malnad / Western Ghats" },
];